import React from "react";

export default function() {
  const { savedForms } = this.state;
  return (
    <div>
      <h3>Saved Forms</h3>
      {savedForms.length === 0 && (
        <div className="placeholder">No saved forms</div>
      )}
      {savedForms.map(({ label, title, url, options, loading, date }, index) =>
        this._renderSavedForm(
          { label, title, url, options, loading, date },
          index
        )
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/saved-forms/view.js